import type { TovVersionResponse } from "contracts/api/client-tov/version.responses";
import { TOV_LEXICON_TYPES, TOV_SCOPE_TYPES } from "contracts/enums/tov-voice";
import { For, Show } from "solid-js";
import { TOV_FIELD_KIND } from "../../enums/tov";
import { type CardEditProps, EditableCard, type FieldSpec } from "./EditForms";
import { Group } from "./Group";
import { CardGrid } from "./primitives";

const LEXICON_FIELDS: FieldSpec[] = [
  { name: "term", label: "Term", kind: TOV_FIELD_KIND.TEXT },
  {
    name: "lexiconType",
    label: "Type",
    kind: TOV_FIELD_KIND.SELECT,
    options: TOV_LEXICON_TYPES,
  },
  {
    name: "replacement",
    label: "Replacement",
    kind: TOV_FIELD_KIND.TEXT,
    optional: true,
  },
  {
    name: "locale",
    label: "Locale",
    kind: TOV_FIELD_KIND.TEXT,
    optional: true,
  },
  {
    name: "scopeType",
    label: "Scope",
    kind: TOV_FIELD_KIND.SELECT,
    options: TOV_SCOPE_TYPES,
  },
  {
    name: "scopeKey",
    label: "Scope key",
    kind: TOV_FIELD_KIND.TEXT,
    optional: true,
  },
  {
    name: "reason",
    label: "Reason",
    kind: TOV_FIELD_KIND.TEXT,
    optional: true,
    grow: true,
  },
];

export function LexiconCards(props: {
  version: TovVersionResponse;
  edit: CardEditProps;
}) {
  return (
    <Group title="Lexicon" empty={props.version.lexicon.length === 0}>
      <CardGrid>
        <For each={props.version.lexicon}>
          {(term) => (
            <EditableCard
              title={term.term}
              tag={term.lexiconType}
              editable={props.edit.editable}
              fields={LEXICON_FIELDS}
              initial={{
                term: term.term,
                lexiconType: term.lexiconType,
                replacement: term.replacement ?? undefined,
                locale: term.locale ?? undefined,
                scopeType: term.scopeType,
                scopeKey: term.scopeKey ?? undefined,
                reason: term.reason ?? undefined,
              }}
              onSave={(values) => props.edit.onEdit("lexicon", term.id, values)}
              onDelete={() => props.edit.onDelete("lexicon", term.id)}
            >
              <Show when={term.replacement}>
                <p class="tov-desc">→ {term.replacement}</p>
              </Show>
              <Show when={term.reason}>
                <p class="tov-sub">{term.reason}</p>
              </Show>
            </EditableCard>
          )}
        </For>
      </CardGrid>
    </Group>
  );
}
